import { VisibleAsset, VisibleAssetPage } from './types';

export function normalizeVisibleAssetPage(
  data: VisibleAssetPage | VisibleAsset[] | null | undefined,
  fallback: { skip?: number; limit?: number } = {},
): VisibleAssetPage {
  const skip = Math.max(0, Number(fallback.skip) || 0);
  const limit = Math.max(1, Number(fallback.limit) || 24);

  if (Array.isArray(data)) {
    return {
      items: data,
      total: data.length,
      skip,
      limit,
    };
  }

  const rawItems = data?.items;
  const items = Array.isArray(rawItems) ? rawItems : [];
  return {
    items,
    total: Number.isFinite(Number(data?.total)) ? Math.max(0, Number(data?.total)) : items.length,
    skip: Number.isFinite(Number(data?.skip)) ? Math.max(0, Number(data?.skip)) : skip,
    limit: Number.isFinite(Number(data?.limit)) ? Math.max(1, Number(data?.limit)) : limit,
  };
}
